import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';


@Component({
    selector: 'app-galeria',
    templateUrl: './galeria.component.html',
    styleUrls: ['./galeria.component.css']
})
export class GaleriaComponent implements OnInit{
    galeriaOpciones: NgxGalleryOptions[];
    galeriaImagenes: NgxGalleryImage[];

    ngOnInit() {
        var alto = (document.getElementById('galeria-section').offsetHeight) - 58;
        this.galeriaOpciones = [
            {
                thumbnailsColumns: 4,
                imageAnimation: NgxGalleryAnimation.Zoom,
                imageAutoPlay: true,
                imageAutoPlayPauseOnHover: true,
                previewAutoPlay: true,
                previewAutoPlayPauseOnHover: true,
                imageAutoPlayInterval: 15000,
                previewAutoPlayInterval: 15000,
                width: '100%',
                height: alto + 'px',
                imageArrowsAutoHide: true,
                thumbnailsArrowsAutoHide: true
            }
        ];
        this.galeriaImagenes = [
            {
                small: '../../../assets/images/Galeria/1-Thumbnail.jpg',
                medium: '../../../assets/images/Galeria/1-Thumbnail.jpg',
                big: '../../../assets/images/Galeria/1-Principal.jpg',
                description: ''
            },
            {
                small: '../../../assets/images/Galeria/2-Thumbnail.jpg',
                medium: '../../../assets/images/Galeria/2-Thumbnail.jpg',
                big: '../../../assets/images/Galeria/2-Principal.jpg',
                description: ''
            },
            {
                small: '../../../assets/images/Galeria/3-Thumbnail.jpg',
                medium: '../../../assets/images/Galeria/3-Thumbnail.jpg',
                big: '../../../assets/images/Galeria/3-Principal.jpg',
                description: ''
            },
            {
                small: '../../../assets/images/Galeria/4-Thumbnail.jpg',
                medium: '../../../assets/images/Galeria/4-Thumbnail.jpg',
                big: '../../../assets/images/Galeria/4-Principal.jpg',
                description: ''
            },
            {
                small: '../../../assets/images/Galeria/5-Thumbnail.jpg',
                medium: '../../../assets/images/Galeria/5-Thumbnail.jpg',
                big: '../../../assets/images/Galeria/5-Principal.jpg',
                description: ''
            },
            {
                small: '../../../assets/images/Galeria/6-Thumbnail.jpg',
                medium: '../../../assets/images/Galeria/6-Thumbnail.jpg',
                big: '../../../assets/images/Galeria/6-Principal.jpg',
                description: ''
            },
            {
                small: '../../../assets/images/Galeria/7-Thumbnail.jpg',
                medium: '../../../assets/images/Galeria/7-Thumbnail.jpg',
                big: '../../../assets/images/Galeria/7-Principal.jpg',
                description: ''
            }
        ];
    }
}



// WEBPACK FOOTER //
// C:/Front-end/[PROYECTO] abordo-empresarial-cli4/[RAMA] actualizarAngular-Analytics/abordo-empresarial-cli4/src/app/componentes/galeria/galeria.component.ts